import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RequestFormBookingExists } from './form/RequestFormBookingExists';
import { RequestFormContainer } from './form/RequestFormContainer';
import { RequestFormError } from './form/RequestFormError';
import { RequestFormPhoneVerificationContainer } from './form/RequestFormPhoneVerificationContainer';
import { RequestFormSuccess } from './form/RequestFormSuccess';
import { QuizAdditionalServicesContainer } from './quiz/QuizAdditionalServicesContainer';
import { QuizPriceRangeContainer } from './quiz/QuizPriceRangeContainer';
import { QuizRoomCount } from './quiz/QuizRoomCountContainer';
import { CONSULTING_FORM_SUBMITTED_COOKIE_NAME, FORM_ANCHOR } from '../../constants/requestForm';
import { useInView } from '../../hooks/useInView';
import { selectFormStep } from '../../selectors/requestFormV2';
import { setFormStep } from '../../slices';
import { EFormStep } from '../../types/requestForm/requestFormV2';
import { getCookie } from '../../utils/cookie';

export const RequestFormV2Container = ({ setIsFormVisible }: { setIsFormVisible: (isVisible: boolean) => void }) => {
  const dispatch = useDispatch();
  const step = useSelector(selectFormStep);
  const [formRef, isFormInView] = useInView<HTMLDivElement>({
    threshold: 0.4,
  });

  React.useEffect(() => {
    const isFormAlreadySend = getCookie(CONSULTING_FORM_SUBMITTED_COOKIE_NAME);

    if (isFormAlreadySend) {
      dispatch(setFormStep(EFormStep.Success));
    }
    setIsFormVisible(isFormInView);
  }, [dispatch, isFormInView, setIsFormVisible]);

  return (
    <div ref={formRef} id={FORM_ANCHOR} data-testid="RequestFormV2">
      {step === EFormStep.Rooms ? <QuizRoomCount /> : null}
      {step === EFormStep.Prices ? <QuizPriceRangeContainer /> : null}
      {step === EFormStep.AdditionalServices ? <QuizAdditionalServicesContainer /> : null}
      {step === EFormStep.Contacts ? <RequestFormContainer /> : null}
      {step === EFormStep.PhoneVerification ? <RequestFormPhoneVerificationContainer /> : null}
      {step === EFormStep.BookingExists ? <RequestFormBookingExists /> : null}
      {step === EFormStep.Success ? <RequestFormSuccess /> : null}
      {step === EFormStep.Error ? <RequestFormError /> : null}
    </div>
  );
};
